import script from "./PreviewBeforeJoin.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewBeforeJoin.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewBeforeJoin.vue?vue&type=style&index=0&id=1f8607b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f8607b0"]])

export default __exports__